import { Component, Inject, OnInit } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";
import { ChatMessageToastDto } from "../../../../services/sse-notification.service";
import { UserImageComponent } from "../user-image/user-image.component";
import { Router } from "@angular/router";
import { UserService } from "../../../../services/user-service.service";


@Component({
  styleUrl: './snackbar-message.component.scss',
  templateUrl: './snackbar-message.component.html',
  imports: [UserImageComponent]
})
export class SnackbarMessageComponent implements OnInit {

  constructor(
    private snackBarRef: MatSnackBarRef<SnackbarMessageComponent>,
    private router: Router,
    private userService: UserService,
    @Inject(MAT_SNACK_BAR_DATA) public data: ChatMessageToastDto
  ) { }

  public ngOnInit(): void {

  }

  /**Close the snackbar*/
  public dismiss(): void {
    this.snackBarRef.dismiss();
  }

  /**Navigate to the provided chat Id*/
  public clickMiddle(): void {
    this.snackBarRef.dismiss();
    this.router.navigate([`/apps/messages/${this.data.ChatId}`]);
  }

  isGuardian(): boolean {
    const currentUser = this.userService.CurrentUserProfile;
    if (!currentUser) return false;

    return currentUser.UserType === 'Guardian';
  }

}
